let waiting_list = (function( $ ) {

	let $anchors;

	let _init = function() {
		$anchors = $( 'a[href=#waiting-list]' );

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _add_to_waiting_list );
		}
	};

	let _add_to_waiting_list = function( e ) {
		let $anchor = $( this );

		let data = {
			action   : 'crate_add_to_waiting_list',
			nonce    : ScriptData.add_to_waiting_list_nonce,
			event_id : $anchor.data( 'event-id' )
		};

		$.post( ScriptData.ajaxurl, data, _add_to_waiting_list_response );

		e.preventDefault();
	};

	let _add_to_waiting_list_response = function( response ) {
		if ( response.success ) {
			window.location.reload();
			return;
		}

		$( '.event-notice .notice' ).html( 'An error has occurred. Please refresh the page and try again' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = waiting_list;